import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import UploadPostcodesModal from "./modal/UploadPostcodesModal";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface IState {
	/**
	 * Indicates if upload postcode modal is visible
	 */
	uploadModalVisible: boolean;
}

/**
 * Postcodes list component.
 */
export default class PostcodesList extends React.Component<{}, IState> {
	constructor(props: {}) {
		super(props);

		this.state = {
			uploadModalVisible: false,
		};
		this.openUploadPostcodesModal = this.openUploadPostcodesModal.bind(this);
		this.closeUploadPostcodesModal = this.closeUploadPostcodesModal.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={"Postcodes"}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={this.downloadPostcodesXlsx}
									   label={"Download Postcodes"}
									   variant={"burgundy"}/>
						<ButtonPrimary onClick={this.openUploadPostcodesModal}
									   label={"Upload Postcodes"}
									   variant={"burgundy"}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				{this.state.uploadModalVisible &&
				<UploadPostcodesModal onSuccess={this.closeUploadPostcodesModal} onCancel={this.closeUploadPostcodesModal}/>}
			</React.Fragment>
		)
	}

	openUploadPostcodesModal() {
		this.setState({uploadModalVisible: true});
	}

	closeUploadPostcodesModal() {
		this.setState({uploadModalVisible: false});
	}

	/**
	 * Download postcodes.
	 */
	downloadPostcodesXlsx() {
		api.instance.postcodeApi.downloadPostcodes().catch(() => Toast.error("Cannot download postcodes", "Postcodes download"));
	}
}
